module.exports = __webpack_public_path__ + "static/media/weight.d02a29e5.svg";